import React, { Component } from 'react';

class ServicesFMS extends Component {
    render() {
      return (
        <React.Fragment>
            <p id="title">Facility Management Services</p>

            <ul>
                <li>
                    MEP
                        <ul>
                            <li>
                                A/C periodical maintenance and service   
                            </li>
                            <li>
                                Water supply, circulation and boosting pumps maintenance and service
                            </li>
                            <li>
                                Water meter readings recording and monitoring
                            </li>
                            <li>
                                Plumbing works and rectifications
                            </li>
                            <li>
                                All electrical panels, connections and light fittings maintenance and rectification
                            </li>
                            <li>
                                Sewage pumps maintenance
                            </li>
                        </ul>
                </li>
                <li>
                    Landscaping
                </li>
                <li>
                    Cleaning
                </li>
                <li>
                    Waste removal
                </li>
                <li>
                    Firefighting equipment maintenance
                </li>
                <li>
                    Fire alarm panels, detectors and modules 
                </li>
                <li>
                    Gate barriers and access control
                </li>
                <li>
                    Swimming pools maintenance and cleaning
                </li>
                <li>
                    Pest control
                </li>
                <li>
                    Home automation system installation and maintenance
                </li>
                <li>
                    Energy consumption monitoring and suggestions on how to reduce it 
                </li>
                <li>
                    Proper implementation of PPM’s
                </li>
            </ul>
        </React.Fragment>
      );
   }
}

export default ServicesFMS;